import { Link } from 'react-router-dom';
import { articles, featuredArticleSlugs } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => featuredArticleSlugs.includes(a.slug));

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-primary-600 text-sm font-medium tracking-wider mb-3">
              精选文章
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              禅意深度阅读
            </h2>
          </div>
          <Link
            to="/category/chan-yi-gu-shi"
            className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}